/**
 * AWS Amplify Configuration
 * 
 * Configures Amplify for Cognito authentication operations
 * Used for password management and other auth operations
 */

import { Amplify } from 'aws-amplify';

// Get Cognito configuration from environment
const userPoolId = 'us-east-2_mMMISmfOQ'; // From context
const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
const region = 'us-east-2';

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN,
          scopes: ['email', 'openid', 'phone', 'profile'],
          redirectSignIn: [import.meta.env.VITE_COGNITO_REDIRECT_URI],
          redirectSignOut: [import.meta.env.VITE_COGNITO_LOGOUT_URI],
          responseType: 'token',
        },
      },
    },
  },
});

console.log('[Amplify] Configured with User Pool:', userPoolId);

export { userPoolId, userPoolClientId, region };
